import { render, staticRenderFns } from "./ConfrontationView.vue?vue&type=template&id=4921ebd0"
import script from "./ConfrontationView.ts?vue&type=script&lang=ts&external"
export * from "./ConfrontationView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports